import { useLoadingStore } from 'stores/loadingStore'
import LoadingAlert from './LoadingAlert'

export default function AppLoading() {
  const loading = useLoadingStore((state) => state.loading)

  return <LoadingAlert loading={loading} />
}
